import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Alert from "sweetalert2";
import AppContext from "../../appContext";

class Lab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      link: this.props.link,
      labCnpj: this.props.labCnpj,
      laboratorio: this.props.laboratorio,
      listaLaboratorio: this.props.AllLabs,
      hasLaboratorio: this.props.labCnpj,
      labId: this.props.labId,
      PossuiProgramaFidelidadeProprio_c: this.props.PossuiProgramaFidelidadeProprio_c
    };

    Lab.contextType = AppContext;
    this.checkHealth = this.checkHealth.bind(this);
  }

  componentDidMount() {
    var tester = new Image();
    tester.onload = this.imageFound;
    tester.onerror = this.imageNotFound;
    tester.src = this.props.logo;
  }

  imageFound = () => {
    this.setState({ labLogo: true });
  };

  imageNotFound = () => {
    this.setState({ labLogo: false });
  };

  checkHealth() {
    this.context.showLoading("Validando laboratório");
    const requestOptions = {
      method: "GET",
      headers: {
        laboratorio: this.state.labCnpj,
      },
    };

    fetch(process.env.REACT_APP_ESSILOR_API + "gestao-produtos-laboratorio/v1/health", requestOptions)
      .then(response => {
        if (response.ok) {
          this.setState({ statusProduct: response.status }, () => {
            fetch(process.env.REACT_APP_ESSILOR_API + "gestao-pedidos-laboratorio/v1/health", requestOptions).then(response => {
              if (response.ok) {
                this.setState({ statusOrder: response.status }, async () => {
                  if (this.state.statusProduct === 200 && this.state.statusOrder === 200) {
                    this.setState({ redirect: true }, this.context.hideLoading());
                  }
                });
              } else {
                return Promise.reject(response);
              }
            });
          });
        } else {
          return Promise.reject(response);
        }
      })
      .catch(error => {
        this.context.hideLoading();
        Alert.fire({
          icon: "warning",
          html: "O serviço está temporariamente indisponível para este laboratório.<br /> O time do Essilor Conecta já está atuando para resolver o problema.",
          width: "auto",
          title: "Aviso",
          confirmButtonColor: "#00518b",
          customClass: {
            confirmButton: "x-follow-order__filter-btn",
          },
        });
      });
  }

  goToOrder = e => {
    e.preventDefault();
    if (this.props.link === "/home") {
      window.location.href = this.props.link;
    } else {
      this.checkHealth();
    }
  };

  render() {
    if (this.state.redirect) {
      if (this.state.link.includes("http")) {
        window.location.href = this.state.link;
      } else {
        return (
          <Redirect
            to={{
              pathname: this.state.link,
              state: {
                labCnpj: this.state.labCnpj,
                redirect: false,
                link: this.props.link,
                hasLaboratorio: this.props.labCnpj,
                laboratorio: this.props.laboratorio,
                listaLaboratorio: this.props.AllLabs,
                labId: this.props.labId,
                PossuiProgramaFidelidadeProprio_c: this.props.PossuiProgramaFidelidadeProprio_c
              },
            }}
          />
        );
      }
    }

    if (this.props.mensagemCadastro) {
      return (
        <div className="labSelect-container">
          <div style={{
            border: "1px solid #333",
            padding: "10px 15px",
            marginBottom: "30px",
            display: "inline-block",
            borderRadius: "5px"
          }}>
            <label style={{ fontWeight: "bold", margin: 0, cursor: "default", fontSize: "15px" }}>
              {this.props.labName}
            </label>
          </div>
        </div>
      );
    }

    return (
      <div
        id={`lab-card-${this.props.labName}`}
        className="labChooseCard"
        role="button"
        tabIndex={0}
        onClick={this.goToOrder}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.goToOrder(e);
          }
        }}
      >
        {this.state.labLogo ? (
          <img className="labChooseCard__img" src={this.props.logo} id={this.props.labName} alt="Escolha seu laboratório" />
        ) : (
          <span className="labChooseCard__text">{this.props.labName}</span>
        )}
      </div>
    );
  }
}

export default Lab;
